module.exports = __webpack_public_path__ + "img/multimodal_mental_health_dx_2.06e48b15.png";